import { render, staticRenderFns } from "./EntityOverviewStandardFieldsWidget.vue?vue&type=template&id=ba45b804"
import script from "./EntityOverviewStandardFieldsWidget.vue?vue&type=script&lang=js"
export * from "./EntityOverviewStandardFieldsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports